import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('hidden.bs.modal', () => {
      // Move focus to body or another visible element
      document.activeElement.blur();
      // Optionally, focus a safe element outside the modal:
      // document.querySelector('body').focus();
    });
  }
}